/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const StripePriceTier = core.serialization.object({
    unitAmount: core.serialization.number(),
    upTo: core.serialization.number(),
});
